
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzPageList from "@/models/MiezzPageList";
import MiezzModal from "@/models/MiezzModal";
import MiezzButton from "@/models/MiezzButton";
import CompanyFollowUpRecordAppService from "@/apis.machine/CompanyFollowUpRecordAppService";
import DtoPageListSearchCompanyFollowUpRecord, {
  DtoPageListSearchCompanyFollowUpRecordDynamicSearchItems,
} from "@/models.machine/DtoPageListSearchCompanyFollowUpRecord";
import DtoPageListCompanyFollowUpRecord from "@/models.machine/DtoPageListCompanyFollowUpRecord";
import DtoListItemCompanyFollowUpRecord, {
  DtoListItemCompanyFollowUpRecordMiezzListItems,
} from "@/models.machine/DtoListItemCompanyFollowUpRecord";
import UiSelectOption from "@/models.machine/UiSelectOption";
import JoinCompanyUserAppService from "@/apis.machine/JoinCompanyUserAppService";
import { EnumCompanyFollowUpRecordStatusOption } from "@/models.machine/EnumCompanyFollowUpRecordStatus";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";

export default class CompanyFollowUpRecordPageList extends Vue {
  @Prop() type?: EnumCompanyType;
  /**分页列表 */
  @Prop() list!: MiezzPageList<
    DtoPageListSearchCompanyFollowUpRecord,
    DtoListItemCompanyFollowUpRecord,
    string
  >;

  users: UiSelectOption<string>[] = [];
  EnumCompanyFollowUpRecordStatusOption = EnumCompanyFollowUpRecordStatusOption;

  /**创建时 */
  created(): void {
    //列表-操作区域宽度
    //this.list.OperationWidth = "100px";
    //列表-传参
    this.list.Dto = new DtoPageListSearchCompanyFollowUpRecord();
    //列表-动态搜索-项
    this.list.DynamicSearchItems =
      DtoPageListSearchCompanyFollowUpRecordDynamicSearchItems;
    for (const item of this.list.DynamicSearchItems) {
      if (item.Prop == "DynamicSearch_CustomerLabel") {
        item.Label =
          this.type == EnumCompanyType.Customer ? "客户企业" : "供应商企业";
      }
    }
    //列表-数据-初始
    this.list.Data = new DtoPageListCompanyFollowUpRecord();
    //列表-列配置
    this.list.Items = DtoListItemCompanyFollowUpRecordMiezzListItems;
    for (const item of this.list.Items) {
      if (item.Prop == "CustomerLabel") {
        item.Label =
          this.type == EnumCompanyType.Customer ? "客户企业" : "供应商企业";
      }
    }
    this.list.HandleFormat = (item, row) => {
      if (item.Prop == "Code") {
        return row.Id;
      } else if (item.Prop == "Methods") {
        return row.Methods?.length == 1
          ? row.Methods.firstOrDefault()?.Method
          : row.Methods?.map((it) => `【${it.Method}】`).join("");
      }
      return undefined;
    };
    //列表-顶部按钮
    this.list.TopButtons = [
      {
        Code: "add",
        Title: "添加",
        Icon: "plus",
        Type: "primary",
        Size: "small",
      },
    ];
    //列表-行按钮
    this.list.RowButtons = [
      {
        Code: "detail",
        Title: "查看详细",
        Icon: "document",
        Type: "default",
        Size: "small",
      },
      {
        Code: "copy",
        Title: "复制",
        MiezzIcon: "copy",
        Type: "default",
        Size: "small",
      },
    ];
    //列表-底部按钮
    this.list.BottomButtons = [
      {
        Code: "batch-delete",
        Label: "删除",
        Icon: "delete",
        Type: "text",
        Message: "是否确认删除",
      },
    ];
    JoinCompanyUserAppService.GetSelect().then((r) => {
      this.users = r.data.Data ?? [];
    });
  }

  /**查询列表 */
  handleGet(): void {
    this.list.Dto!.CompanyType = this.type;
    CompanyFollowUpRecordAppService.Get(this.list.Dto).then((r) => {
      this.list.Data = r.data.Data;
    });
  }

  handleLinkClick(row: DtoListItemCompanyFollowUpRecord): void {
    const link = row.Link;
    if (
      link &&
      /^(http|https):\/\/[a-zA-Z0-9.-]+(:[0-9]+)?(\/[^ ]*)?$/.test(link)
    ) {
      window.open(link);
    } else {
      ElMessage.warning("链接地址无效，无法打开");
    }
  }

  /**顶部按钮点击 */
  handleTopButtonClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      //新增
      case "add":
        this.$router.push(`${this.$route.path}/add`);
        complete();
        break;
      default:
        break;
    }
  }

  /**行按钮点击 */
  handleRowButtonClick(
    btn: MiezzButton,
    row: DtoListItemCompanyFollowUpRecord,
    complete: () => void
  ): void {
    switch (btn.Code) {
      //详细
      case "detail":
        this.$router.push(`${this.$route.path}/detail/${row.Id}`);
        complete();
        break;
      case "copy":
        this.$router.push(
          `${this.$route.path}/add?CustomerId=${row.CustomerId}&CustomerLabel=${row.CustomerLabel}&FollowUpPersonId=${row.FollowUpPersonId}&FollowUpPersonLabel=${row.FollowUpPersonLabel}`
        );
        break;
      default:
        break;
    }
  }

  handleRowDbClick(row: DtoListItemCompanyFollowUpRecord): void {
    this.$router.push(`${this.$route.path}/detail/${row.Id}`);
  }

  /**底部按钮点击 */
  handleBottomButtonClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      //批量删除
      case "batch-delete":
        CompanyFollowUpRecordAppService.Delete(this.list.SelectIds)
          .then(() => {
            this.handleGet();
            complete();
          })
          .catch(complete);
        break;
      default:
        break;
    }
  }
}
